import { render } from "./Forgot.vue?vue&type=template&id=bd5b0920&scoped=true&ts=true"
import script from "./Forgot.vue?vue&type=script&lang=ts"
export * from "./Forgot.vue?vue&type=script&lang=ts"

import "./Forgot.vue?vue&type=style&index=0&id=bd5b0920&lang=stylus"
import "./Forgot.vue?vue&type=style&index=1&id=bd5b0920&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd5b0920"]])

export default __exports__